import http from '@/config/api';
import router from '@/router';
import { mergeArrays } from '@/helpers/function/format';

export default {
  async getTicketList({ commit }, params) {
    const directory = params?.directory || router.currentRoute.value?.params.directory;
    const response = await http.get(`/event/${directory}/tickets`);
    if (response) {
      let data = response?.data?.list.map(e => ({...e, times: 0}));
      const paymentTicketList = JSON.parse(sessionStorage.getItem('PAYMENT_TICKET_LIST'));
      if (paymentTicketList?.length > 0) data = mergeArrays(data, paymentTicketList);
      commit('SET_TICKET_LIST', data);
      return data;
    }
  },
  async getChargeTicketList({ commit }, params) {
    const directory = params?.directory || router.currentRoute.value?.params.directory;
    const response = await http.get(`/event/${directory}/tickets/list/charge`);
    if (response) {
      let data = response?.data?.list.map(e => ({...e, times: 0}));
      const chargeTicketList = JSON.parse(sessionStorage.getItem('CHARGE_TICKET_LIST')) || JSON.parse(localStorage.getItem('CHARGE_TICKET_LIST'));
      if (chargeTicketList?.length > 0) data = mergeArrays(data, chargeTicketList);
      commit('SET_CHARGE_TICKET_LIST', data);
      return data;
    }
  },
  resetChargeTicketList({ commit }) {
    commit('RESET_CHARGE_TICKET_LIST');
  },
  async ticketQrCode(_, payload) {
    const directory = payload?.directory || router.currentRoute.value?.params.directory;
    const response = await http
      .post(`event/${directory}/qrcode`, payload)
      .then(
        (res) => res.data,
        (err) => ({
          error: {
            ...err,
          },
        })
      );
    return response;
  },
  async currencyQrCode(_, payload) {
    const directory = payload?.directory || router.currentRoute.value?.params.directory;
    const response = await http
      .post(`event/${directory}/qrcurrency`, payload)
      .then(
        (res) => res.data,
        (err) => ({
          error: {
            ...err,
          },
        })
      );
    return response;
  },
};
